import { render, staticRenderFns } from "./CreateRequisiteDlg.vue?vue&type=template&id=6f45c828&"
import script from "./CreateRequisiteDlg.vue?vue&type=script&lang=js&"
export * from "./CreateRequisiteDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports